module.exports = __webpack_public_path__ + "static/media/bali-bombings-feature-banner-sm@2x.c89d6bec.png";